import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ContainersModule } from "../containers/containers.module";
import { InputPasteToDateDirective } from "../directives/paste-data.directive";
import { MaterialModule } from "./material.module";

@NgModule({
	imports: [CommonModule, ReactiveFormsModule, FormsModule, ContainersModule, MaterialModule],
	exports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		ContainersModule,
		MaterialModule,
		InputPasteToDateDirective
	],
	declarations: [InputPasteToDateDirective]
})
export class SharedModule {}
